import React from 'react';
import PropTypes from 'prop-types';

import PressList from './PressList';

const PressRelease = props => {
  const { data, isOpen, onClose } = props;

  const pressData = {
    ...data,
    pressList: data.pressList.map(item => {
      const { source, title, language } = item;
      return {
        ...item,
        subtitle: source,
        title: `${title} (${language})`,
      };
    }),
  };

  return <PressList isOpen={isOpen} onClose={onClose} data={pressData} />;
};

PressRelease.propTypes = {
  data: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default PressRelease;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/press/PressMention.js